<div mat-dialog-header
  ><h1
    >{{globals.user.email ? data.createNew ? `Create New Automated Report` : `Edit Automated Report` : `Error - Could Not Find Email Address`}}</h1
  >
</div>
<div mat-dialog-content class="dialog-container">
  @if (globals.user.email) {
    <div>
      <div class="fields-container">
        <div class="w-33">
          <mat-form-field class="w-100">
            <mat-label>Title</mat-label>
            <input matInput [(ngModel)]="title" />
          </mat-form-field>
        </div>
        <div class="w-66">
          <mat-form-field class="w-100">
            <mat-label>Description</mat-label>
            <input matInput [(ngModel)]="description" />
          </mat-form-field>
        </div>
        <div class="w-25">
          <mat-form-field class="w-100">
            <mat-label>Grids</mat-label>
            <mat-select
              [(ngModel)]="gridName"
              [disabled]="lockGridName"
              (selectionChange)="gridNameChange($event)"
            >
              @for (option of availableGridNames; track $index) {
                <mat-option [value]="option">
                  {{ getGridNameLabel(option) }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        @if (!data.dataItem) {
          <div class="w-50">
            <mat-form-field class="w-100">
              <mat-label>Filters</mat-label>
              <mat-select [(ngModel)]="filterName" [disabled]="!gridName">
                @for (group of filterGroups; track group) {
                  <mat-optgroup [label]="getGroupLabel(group)">
                    @for (option of this.savedFilters; track $index) {
                      @if (option.Scope === group && option.Grid === gridName) {
                        <mat-option [value]="option.FilterID">
                          {{ option.Name }}
                        </mat-option>
                      }
                    }
                  </mat-optgroup>
                }
              </mat-select>
            </mat-form-field>
          </div>
        } @else {
          <div class="w-50">
            <mat-form-field class="w-100">
              <mat-label>Filters</mat-label>
              <mat-select [(ngModel)]="filterNameStatic" [disabled]="true">
                <mat-option [value]="filterNameStatic">
                  {{ filterNameStatic }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        }

        <div class="w-50">
          <mat-form-field class="w-100">
            <mat-label>Cadence</mat-label>
            <mat-select
              [(ngModel)]="selectedCadence"
              (selectionChange)="onCadenceChange()"
            >
              @for (option of cadenceTypes; track $index) {
                <mat-option [value]="option">
                  {{ getCadenceLabel(option) }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (selectedCadence === 'Weekly') {
            <mat-form-field class="w-100">
              <mat-label>Select Day of the Week</mat-label>
              <mat-select [(ngModel)]="selectedDayOfWeek">
                @for (day of daysOfWeek; track $index) {
                  <mat-option [value]="day">
                    {{ getWeekdayLabel(day) }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (selectedCadence === 'Monthly') {
            <mat-form-field class="w-100">
              <mat-label>Select Day of the Month</mat-label>
              <mat-select
                [(ngModel)]="selectedDayOfMonth"
                (selectionChange)="onDayOfMonthChange()"
              >
                @for (day of daysOfMonth; track $index) {
                  <mat-option [value]="day">
                    {{ getMonthlySuffix(+day) }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          @if (showMonthlyWarning) {
            <div class="warning px-2">
              <p>
                Warning: If the selected day does not exist in a month (e.g.,
                30th or 31st), the report will be sent on the last day of the
                month.
              </p>
            </div>
          }
        </div>

        <div class="w-100">
          <mat-checkbox [(ngModel)]="confirmCheck"
            ><div>
              I agree to have CapitalROCK send the requested data to me via
              email.</div
            ><div>Email on file: {{ globals.user.email }}</div></mat-checkbox
          >
        </div>
      </div>
    </div>
  } @else {
    <div
      >Automated reports sends generated reports via email. This user does not
      have an email address associated with it. Please reach out to your
      administrator.</div
    >
  }
</div>
<div mat-dialog-actions class="row buttons">
  <div>
    <span class="pull-right">
      <button mat-button color="warn" (click)="dialogRef.close('cancel')">
        Cancel
      </button>
      @if (globals.user.email) {
        <button
          mat-raised-button
          color="accent"
          (click)="submitData()"
          [disabled]="checkFields()"
        >
          Submit
        </button>
      }
    </span>
  </div>
</div>
